import React from 'react'

const HLAPresidents = () => {
  return (
    <div name='hlapresidents' className='w-full  bg-[#06173179] text-white py-10'>
      <section className="text-white-600 body-font">
  <div className="container px-5 py-16 mx-auto">
    <div className="flex flex-col text-center w-full mb-20">
      {/* <h1 className="sm:text-4xl text-3xl font-medium title-font mb-2 text-gray-900">
      HLAPresidents
      </h1> */}

      <div className='text-center pl-4'>
            <p className='text-4xl font-bold inline border-b-4 border-pink-600'>
            HLA Presidents
            </p>
          </div>


      {/* <p className="lg:w-2/3 mx-auto leading-relaxed text-base">
        Banh mi cornhole echo park skateboard authentic crucifix neutra tilde
        lyft biodiesel artisan direct trade mumblecore 3 wolf moon twee
      </p> */}
    </div>
    <div className="lg:w-2/3 w-full mx-auto overflow-auto">
      <table className="table-auto w-full text-lg text-left whitespace-no-wrap  bg-emerald-500 title-font tracking-wider">
        <thead className='text-gray-900 bg-gray-100'>
          <tr>
            <th className="columns-2 px-4 py-3 title-font tracking-wider rounded-tl rounded-bl">
              Sr.No.
            </th>
            <th className="columns-2 px-4 py-3 title-font tracking-wider">
              President's Name
            </th>             
            <th className="columns-2 px-4 py-3 title-font tracking-wider rounded-tr rounded-br">
            Period
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td className="border-t-2 px-4 py-3">1.</td>
            <td className="border-t-2 px-4 py-3">Sh. M. L. Bhagi</td>
            <td className="border-t-2 px-4 py-3">1966–1976</td>           
          </tr>
          <tr>
            <td className="border-t-2 px-4 py-3">2.</td>
            <td className="border-t-2 px-4 py-3">Sh. K. S. Dalal</td>
            <td className="border-t-2 px-4 py-3">1976–1988</td>           
          </tr>

          <tr>
            <td className="border-t-2 px-4 py-3">3.</td>
            <td className="border-t-2 px-4 py-3">Dr. N. K. Sharma</td>
            <td className="border-t-2 px-4 py-3">1988–1996</td>           
          </tr>

          <tr>
            <td className="border-t-2 px-4 py-3">4.</td>
            <td className="border-t-2 px-4 py-3">Sh. Raj Pal Lohan</td>
            <td className="border-t-2 px-4 py-3">1996-1998</td>           
          </tr>

          <tr>
            <td className="border-t-2 px-4 py-3">5.</td>
            <td className="border-t-2 px-4 py-3">Sh. V. K. Sharma</td>
            <td className="border-t-2 px-4 py-3">1998-2002</td>           
          </tr>

          <tr>
            <td className="border-t-2 px-4 py-3">6.</td>
            <td className="border-t-2 px-4 py-3">Sh. R. D. Mehla</td>
            <td className="border-t-2 px-4 py-3">2002-2015</td>           
          </tr>

          <tr>
            <td className="border-t-2 px-4 py-3">7.</td>
            <td className="border-t-2 px-4 py-3">Dr Manoj K Joshi</td>
            <td className="border-t-2 px-4 py-3">2015-2017</td>           
          </tr>

          <tr>
            <td className="border-t-2 px-4 py-3">8.</td>
            <td className="border-t-2 px-4 py-3">Dr. Narender Shokeen</td>
            <td className="border-t-2 px-4 py-3">2017-2022</td>           
          </tr>

          <tr>
            <td className="border-t-2 px-4 py-3">9.</td>
            <td className="border-t-2 px-4 py-3">Dr. Rupesh Gaur </td>
            <td className="border-t-2 px-4 py-3">2022 to Continue...</td>           
          </tr>

         
         
      
          
          {/* <tr>
            <td className="border-t-2 border-gray-200 px-4 py-3">Business</td>
            <td className="border-t-2 border-gray-200 px-4 py-3">36 Mb/s</td>
            <td className="border-t-2 border-gray-200 px-4 py-3">40 GB</td>
            
          </tr> */}
          
        </tbody>
      </table>
    </div>
     
  </div>
</section>



    </div>
  )
}

export default HLAPresidents
